import axios from "../axiosInstance"

export const getResources = async () => {
  try {
    const res = await axios.get("/resources/all")
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch resources")
    }
    return data.resources
  } catch (error) {
    console.error("Error fetching resources:", error)
    throw error
  }
}
